import { NestedCustomerSatisfaction } from "../../../graphql/models";

import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import { SvgIconTypeMap } from "@material-ui/core";

type IconProps = Omit<SvgIconTypeMap<{}, "svg">["props"], "children">;

export type CsiRatingProps = {
  customerSatisfaction: Pick<NestedCustomerSatisfaction, "rating">;
} & Partial<IconProps>;
export default function CsiRating(props: CsiRatingProps) {
  const { customerSatisfaction, ...iconProps } = props;

  if (customerSatisfaction.rating == null) {
    return <></>;
  }

  return customerSatisfaction.rating === 1 ? (
    <ThumbDownIcon {...iconProps} />
  ) : (
    <ThumbUpIcon {...iconProps} />
  );
}
